/**
 * 회원명부 데이터
 */
const MemberDirectoryData = [
            {
                "book_id" : 10409,
                "book_title" : "(監理敎會協成神學校) 協成神學錄 ",
                "book_title_ko" : "(감리교회협성신학교) 협성신학록 ",
                "publish_date" : "1922.00.00",
                "publish_year" : 1922,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "監理敎會協成神學校",
                "publisher_ko" : "감리교회협성신학교",
                "library" : "△",
                "school_id" : 52940,
                "primaryname" : "監理敎會協成神學校",
                "primaryname_ko" : "감리교회협성신학교"
            },
            {
                "book_id" : 10409,
                "book_title" : "(監理敎會協成神學校) 協成神學錄 ",
                "book_title_ko" : "(감리교회협성신학교) 협성신학록 ",
                "publish_date" : "1922.00.00",
                "publish_year" : 1922,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "監理敎會協成神學校",
                "publisher_ko" : "감리교회협성신학교",
                "library" : "△",
                "school_id" : 52757,
                "primaryname" : "監理敎會協成神學校",
                "primaryname_ko" : "감리교회협성신학교"
            },
            {
                "book_id" : 10410,
                "book_title" : "(慶南理髮學校) 卒業者名簿報告 (1937-1944)",
                "book_title_ko" : "(경남리발학교) 졸업자명부보고 (1937-1944)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "慶南理髮學校",
                "publisher_ko" : "경남리발학교",
                "library" : "△",
                "school_id" : 27630,
                "primaryname" : "慶南理髮學校",
                "primaryname_ko" : "경남리발학교"
            },
            {
                "book_id" : 10410,
                "book_title" : "(慶南理髮學校) 卒業者名簿報告 (1937-1944)",
                "book_title_ko" : "(경남리발학교) 졸업자명부보고 (1937-1944)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "慶南理髮學校",
                "publisher_ko" : "경남리발학교",
                "library" : "△",
                "school_id" : 52778,
                "primaryname" : "慶南理髮學校",
                "primaryname_ko" : "경남이발학교"
            },
            {
                "book_id" : 10411,
                "book_title" : "(儆新學校) 會員名簿 (昭和18年)",
                "book_title_ko" : "(경신학교) 회원명부 (소화18년)",
                "publish_date" : "1943.09.00",
                "publish_year" : 1943,
                "publish_month" : 9,
                "publish_day" : 0,
                "publisher" : "頭山巖 儆新學校 同門會",
                "publisher_ko" : "두산암 경신학교 동문회",
                "library" : "○",
                "school_id" : 52760,
                "primaryname" : "儆新學校",
                "primaryname_ko" : "경신학교"
            },
            {
                "book_id" : 10412,
                "book_title" : "(義明學校) 學友會 會員名簿 ",
                "book_title_ko" : "(의명학교) 학우회 회원명부 ",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "義明學校 學友會",
                "publisher_ko" : "의명학교 학우회",
                "library" : "△",
                "school_id" : 52764,
                "primaryname" : "義明學校",
                "primaryname_ko" : "의명학교"
            },
            {
                "book_id" : 10413,
                "book_title" : "(耶蘇敎長老會神學校) 神學生名簿表 ",
                "book_title_ko" : "(야소교장로회신학교) 신학생명부표 ",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "불명",
                "publisher_ko" : "불명",
                "library" : "",
                "school_id" : 52779,
                "primaryname" : "耶蘇敎長老會神學校",
                "primaryname_ko" : "아소교장로회신학교"
            },
            {
                "book_id" : 10414,
                "book_title" : "(中東學校) 會員名簿 第20號 (昭和17年11月 現在)",
                "book_title_ko" : "(중동학교) 회원명부 제20호 (소화17년11월 현재)",
                "publish_date" : "1942.12.00",
                "publish_year" : 1942,
                "publish_month" : 12,
                "publish_day" : 0,
                "publisher" : "中東同窓會",
                "publisher_ko" : "중동동창회",
                "library" : "○",
                "school_id" : 52777,
                "primaryname" : "中東學校",
                "primaryname_ko" : "중동학교"
            },
            {
                "book_id" : 10435,
                "book_title" : "(京城第一高等女學校) 白楊 創立第25週年 記念誌",
                "book_title_ko" : "(경성제일고등여학교) 백양 창립제25주년 기념지",
                "publish_date" : "1933.05.23",
                "publish_year" : 1933,
                "publish_month" : 5,
                "publish_day" : 23,
                "publisher" : "京城第一公立高等女學校",
                "publisher_ko" : "경성제일공립고등여학교",
                "library" : "서울대○",
                "school_id" : 52955,
                "primaryname" : "京城第一公立高等女學校",
                "primaryname_ko" : "경성제일공립고등여학교"
            },
            {
                "book_id" : 10435,
                "book_title" : "(京城第一高等女學校) 白楊 創立第25週年 記念誌",
                "book_title_ko" : "(경성제일고등여학교) 백양 창립제25주년 기념지",
                "publish_date" : "1933.05.23",
                "publish_year" : 1933,
                "publish_month" : 5,
                "publish_day" : 23,
                "publisher" : "京城第一公立高等女學校",
                "publisher_ko" : "경성제일공립고등여학교",
                "library" : "서울대○",
                "school_id" : 52797,
                "primaryname" : "京城第一高等女學校",
                "primaryname_ko" : "경성제일고등여학교"
            },
            {
                "book_id" : 10436,
                "book_title" : "(京城第一高等女學校) 會員名簿 ",
                "book_title_ko" : "(경성제일고등여학교) 회원명부 ",
                "publish_date" : "1939.12.20",
                "publish_year" : 1939,
                "publish_month" : 12,
                "publish_day" : 20,
                "publisher" : "京城第一高等女學校",
                "publisher_ko" : "경성제일고등여학교",
                "library" : "",
                "school_id" : 27294,
                "primaryname" : "京城第一高等女學校",
                "primaryname_ko" : "경성제일고등여학교"
            },
            {
                "book_id" : 10436,
                "book_title" : "(京城第一高等女學校) 會員名簿 ",
                "book_title_ko" : "(경성제일고등여학교) 회원명부 ",
                "publish_date" : "1939.12.20",
                "publish_year" : 1939,
                "publish_month" : 12,
                "publish_day" : 20,
                "publisher" : "京城第一高等女學校",
                "publisher_ko" : "경성제일고등여학교",
                "library" : "",
                "school_id" : 52797,
                "primaryname" : "京城第一高等女學校",
                "primaryname_ko" : "경성제일고등여학교"
            },
            {
                "book_id" : 10437,
                "book_title" : "(京畿高等女學校) 會員名簿 ",
                "book_title_ko" : "(경기고등여학교) 회원명부 ",
                "publish_date" : "1939.12.20",
                "publish_year" : 1939,
                "publish_month" : 12,
                "publish_day" : 20,
                "publisher" : "京畿公立高等女學校 慶雲會",
                "publisher_ko" : "경기공립고등여학교 경운회",
                "library" : "",
                "school_id" : 52798,
                "primaryname" : "京畿高等女學校",
                "primaryname_ko" : "경성여자고등보통학교"
            },
            {
                "book_id" : 10438,
                "book_title" : "(漢城高等女學校) 會員名簿 ",
                "book_title_ko" : "(한성고등여학교) 회원명부 ",
                "publish_date" : "1939.12.20",
                "publish_year" : 1939,
                "publish_month" : 12,
                "publish_day" : 20,
                "publisher" : "京畿公立高等女學校 慶雲會",
                "publisher_ko" : "경기공립고등여학교 경운회",
                "library" : "",
                "school_id" : 52799,
                "primaryname" : "漢城高等女學校",
                "primaryname_ko" : "한성고등여학교"
            },
            {
                "book_id" : 10561,
                "book_title" : "(景福中學校) 同窓會員名簿 (昭和十九年四月現在)",
                "book_title_ko" : "(경복중학교) 동창회원명부 (소화19년4월현재)",
                "publish_date" : "1944.00.00",
                "publish_year" : 1944,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "京城第二高等普通學校 同窓會",
                "publisher_ko" : "경성제이고등보통학교 동창회",
                "library" : "△",
                "school_id" : 52801,
                "primaryname" : "景福中學校",
                "primaryname_ko" : "경복중학교"
            },
            {
                "book_id" : 10562,
                "book_title" : "(大邱高等普通學校) 회원명부 1965년",
                "book_title_ko" : "(대구고등보통학교) 회원명부 1965년",
                "publish_date" : "1965.05.16",
                "publish_year" : 1965,
                "publish_month" : 5,
                "publish_day" : 16,
                "publisher" : "李孝祥 慶北中高等學校(旧 大邱高普) 同窓會",
                "publisher_ko" : "이효상 경북중고등학교(구 대구고보) 동창회",
                "library" : "△",
                "school_id" : 52808,
                "primaryname" : "大邱高等普通學校",
                "primaryname_ko" : "대구고등보통학교"
            },
            {
                "book_id" : 10563,
                "book_title" : "(徽文高等普通學校) 회원명부 ",
                "book_title_ko" : "(휘문고등보통학교) 회원명부 ",
                "publish_date" : "1942.02.25",
                "publish_year" : 1942,
                "publish_month" : 2,
                "publish_day" : 25,
                "publisher" : "新垣永昌  徽文高等普通學校 文友會 學藝部",
                "publisher_ko" : "신원영창  휘문고등보통학교 문우회 학예부",
                "library" : "△",
                "school_id" : 52818,
                "primaryname" : "徽文高等普通學校",
                "primaryname_ko" : "휘문고등보통학교"
            },
            {
                "book_id" : 10678,
                "book_title" : "(慶北大學校師範大學) 伏賢會員名簿 (1966年11月末 現在)",
                "book_title_ko" : "(경북대학교사범대학) 복현회원명부 (1966년11월말 현재)",
                "publish_date" : "1966.11.00",
                "publish_year" : 1966,
                "publish_month" : 11,
                "publish_day" : 0,
                "publisher" : "慶北大學校 師範大學 同窓會",
                "publisher_ko" : "경북대학교 사범대학 동창회",
                "library" : "",
                "school_id" : 52835,
                "primaryname" : "慶北大學校師範大學",
                "primaryname_ko" : "경북대학교 사범대학"
            },
            {
                "book_id" : 10750,
                "book_title" : "(釜山第二商業學校) 同窓會名簿 ",
                "book_title_ko" : "(부산제이상업학교) 동창회명부 ",
                "publish_date" : "1941.12.28",
                "publish_year" : 1941,
                "publish_month" : 12,
                "publish_day" : 28,
                "publisher" : "長野祐廣 釜山第二公立商業學校 同窓會",
                "publisher_ko" : "장야우광 부산제이공립상업학교 동창회",
                "library" : "○",
                "school_id" : 52845,
                "primaryname" : "釜山第二商業學校",
                "primaryname_ko" : "부산제이상업학교"
            },
            {
                "book_id" : 10751,
                "book_title" : "(尙州農蠶學校) 校友會 會員名簿 ",
                "book_title_ko" : "(상주농잠학교) 교우회 회원명부 ",
                "publish_date" : "1937.00.00",
                "publish_year" : 1937,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "尙州農蠶學校 校友會",
                "publisher_ko" : "상주농잠학교 교우회",
                "library" : "",
                "school_id" : 52879,
                "primaryname" : "尙州農蠶學校",
                "primaryname_ko" : "상주농잠학교"
            },
            {
                "book_id" : 10752,
                "book_title" : "(尙州農蠶學校) 校友會 會員名簿 ",
                "book_title_ko" : "(상주농잠학교) 교우회 회원명부 ",
                "publish_date" : "1938.00.00",
                "publish_year" : 1938,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "尙州農蠶學校 校友會",
                "publisher_ko" : "상주농잠학교 교우회",
                "library" : "",
                "school_id" : 52879,
                "primaryname" : "尙州農蠶學校",
                "primaryname_ko" : "상주농잠학교"
            },
            {
                "book_id" : 10753,
                "book_title" : "(全州農業學校) 會員氏名錄 ",
                "book_title_ko" : "(전주농업학교) 회원씨명록 ",
                "publish_date" : "1942.12.10",
                "publish_year" : 1942,
                "publish_month" : 12,
                "publish_day" : 10,
                "publisher" : "불명",
                "publisher_ko" : "불명",
                "library" : "국립중앙도서관△",
                "school_id" : 52877,
                "primaryname" : "全州農業學校",
                "primaryname_ko" : "전주농업학교"
            },
            {
                "book_id" : 10754,
                "book_title" : "(濟州農業學校) 會員名簿 (1930年 3月 現在)",
                "book_title_ko" : "(제주농업학교) 회원명부 (1930년 3월 현재)",
                "publish_date" : "1930.03.00",
                "publish_year" : 1930,
                "publish_month" : 3,
                "publish_day" : 0,
                "publisher" : "濟州公立農業學校 校友會",
                "publisher_ko" : "제주공립농업학교 교우회",
                "library" : "△",
                "school_id" : 52880,
                "primaryname" : "濟州農業學校",
                "primaryname_ko" : "제주농업학교"
            },
            {
                "book_id" : 10755,
                "book_title" : "(淸州農業學校) 同窓會員名簿 ",
                "book_title_ko" : "(청주농업학교) 동창회원명부 ",
                "publish_date" : "1943.02.28",
                "publish_year" : 1943,
                "publish_month" : 2,
                "publish_day" : 28,
                "publisher" : "불명",
                "publisher_ko" : "불명",
                "library" : "△",
                "school_id" : 52881,
                "primaryname" : "淸州農業學校",
                "primaryname_ko" : "청주농업학교"
            },
            {
                "book_id" : 10756,
                "book_title" : "(洪城農業專修學校) 同窓會名簿 ",
                "book_title_ko" : "(홍성농업전수학교) 동창회명부 ",
                "publish_date" : "1944.07.27",
                "publish_year" : 1944,
                "publish_month" : 7,
                "publish_day" : 27,
                "publisher" : "洪城公立農業專修學校 同窓會",
                "publisher_ko" : "홍성공립농업전수학교 동창회",
                "library" : "△",
                "school_id" : 52882,
                "primaryname" : "洪城農業專修學校",
                "primaryname_ko" : "홍성농업전수학교"
            },
            {
                "book_id" : 10807,
                "book_title" : "(進明女子高等普通學校) 會員名簿 (昭和7年7月 調)",
                "book_title_ko" : "(진명여자고등보통학교) 회원명부 (소화7년7월 조)",
                "publish_date" : "1932.07.25",
                "publish_year" : 1932,
                "publish_month" : 7,
                "publish_day" : 25,
                "publisher" : "南相瓚 進明女學校 同窓會",
                "publisher_ko" : "남상찬 진명여학교 동창회",
                "library" : "○",
                "school_id" : 52890,
                "primaryname" : "進明女子高等普通學校",
                "primaryname_ko" : "진명여자고등보통학교"
            },
            {
                "book_id" : 10923,
                "book_title" : "(京城高等商業學校) 會員名簿 ",
                "book_title_ko" : "(경성고등상업학교) 회원명부 ",
                "publish_date" : "1944.02.20",
                "publish_year" : 1944,
                "publish_month" : 2,
                "publish_day" : 20,
                "publisher" : "불명",
                "publisher_ko" : "불명",
                "library" : "",
                "school_id" : 52912,
                "primaryname" : "京城高等商業學校",
                "primaryname_ko" : "경성고등상업학교"
            },
            {
                "book_id" : 10924,
                "book_title" : "(普成專門學校) 會員名簿 (昭和14年 12月 現在)",
                "book_title_ko" : "(보성전문학교) 회원명부 (소화14년 12월 현재)",
                "publish_date" : "1939.12.25",
                "publish_year" : 1939,
                "publish_month" : 12,
                "publish_day" : 25,
                "publisher" : "吳一澈 普成專門學校 校友會",
                "publisher_ko" : "오일철 보성전문학교 교우회",
                "library" : "○",
                "school_id" : 52901,
                "primaryname" : "普成專門學校",
                "primaryname_ko" : "보성전문학교"
            },
            {
                "book_id" : 10925,
                "book_title" : "(普成專門學校) 會員名簿 (昭和15年 12月 現在)",
                "book_title_ko" : "(보성전문학교) 회원명부 (소화15년 12월 현재)",
                "publish_date" : "1940.12.00",
                "publish_year" : 1940,
                "publish_month" : 12,
                "publish_day" : 0,
                "publisher" : "普成專門學校 校友會",
                "publisher_ko" : "보성전문학교 교우회",
                "library" : "독립기념관△",
                "school_id" : 52901,
                "primaryname" : "普成專門學校",
                "primaryname_ko" : "보성전문학교"
            },
            {
                "book_id" : 10926,
                "book_title" : "私立セブランス聯合醫學專門學校看護婦養成所一覽: Severance Union Medical College Training School for  Nurse's  catalogue 1918 (大正7年6月)",
                "book_title_ko" : "사립セブランス연합의학전문학교간호부양성소일람: Severance Union Medical College Training School for  Nurse's  catalogue 1918 (대정7년6월)",
                "publish_date" : "1918.00.00",
                "publish_year" : 1918,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "セブランス聯合醫學專門學校",
                "publisher_ko" : "セブランス연합의학전문학교",
                "library" : "연세대",
                "school_id" : 19044,
                "primaryname" : "セブランス聯合醫學專門學校",
                "primaryname_ko" : "セブランス연합의학전문학교"
            },
            {
                "book_id" : 10926,
                "book_title" : "私立セブランス聯合醫學專門學校看護婦養成所一覽: Severance Union Medical College Training School for  Nurse's  catalogue 1918 (大正7年6月)",
                "book_title_ko" : "사립セブランス연합의학전문학교간호부양성소일람: Severance Union Medical College Training School for  Nurse's  catalogue 1918 (대정7년6월)",
                "publish_date" : "1918.00.00",
                "publish_year" : 1918,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "セブランス聯合醫學專門學校",
                "publisher_ko" : "セブランス연합의학전문학교",
                "library" : "연세대",
                "school_id" : 52916,
                "primaryname" : "セブランス聯合醫學專門學校看護婦養成所",
                "primaryname_ko" : "세브란스연합의학전문학교 간호부양성소"
            },
            {
                "book_id" : 10927,
                "book_title" : "(セブランス聯合醫學專門學校看護婦養成所) 會員名簿 ",
                "book_title_ko" : "(セブランス연합의학전문학교간호부양성소) 회원명부 ",
                "publish_date" : "1944.02.20",
                "publish_year" : 1944,
                "publish_month" : 2,
                "publish_day" : 20,
                "publisher" : "불명",
                "publisher_ko" : "불명",
                "library" : "",
                "school_id" : 52916,
                "primaryname" : "セブランス聯合醫學專門學校看護婦養成所",
                "primaryname_ko" : "세브란스연합의학전문학교 간호부양성소"
            },
            {
                "book_id" : 10928,
                "book_title" : "(セブランス聯合醫學專門學校) Activities of Severance Union Medical College and Severance Hospital 1927-1928 ",
                "book_title_ko" : "(セブランス연합의학전문학교) Activities of Severance Union Medical College and Severance Hospital 1927-1928 ",
                "publish_date" : "1928.00.00",
                "publish_year" : 1928,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "",
                "publisher_ko" : "",
                "library" : "연세대",
                "school_id" : 52903,
                "primaryname" : "セブランス聯合醫學專門學校",
                "primaryname_ko" : "세브란스연합의학전문학교"
            },
            {
                "book_id" : 10929,
                "book_title" : "(セブランス聯合醫學專門學校) Severance Union Medical College : catalogue 1917-1918 ",
                "book_title_ko" : "(セブランス연합의학전문학교) Severance Union Medical College : catalogue 1917-1918 ",
                "publish_date" : "1918.00.00",
                "publish_year" : 1918,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "",
                "publisher_ko" : "",
                "library" : "연세대",
                "school_id" : 52903,
                "primaryname" : "セブランス聯合醫學專門學校",
                "primaryname_ko" : "세브란스연합의학전문학교"
            },
            {
                "book_id" : 10930,
                "book_title" : "(セブランス聯合醫學專門學校) Severance Union Medical College :catalogue 1925-1926 ",
                "book_title_ko" : "(セブランス연합의학전문학교) Severance Union Medical College :catalogue 1925-1926 ",
                "publish_date" : "1926.00.00",
                "publish_year" : 1926,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "",
                "publisher_ko" : "",
                "library" : "연세대",
                "school_id" : 52903,
                "primaryname" : "セブランス聯合醫學專門學校",
                "primaryname_ko" : "세브란스연합의학전문학교"
            },
            {
                "book_id" : 10931,
                "book_title" : "(セブランス聯合醫學專門學校) 校友會員住所及名簿 ",
                "book_title_ko" : "(セブランス연합의학전문학교) 교우회원주소급명부 ",
                "publish_date" : "1934.10.00",
                "publish_year" : 1934,
                "publish_month" : 10,
                "publish_day" : 0,
                "publisher" : "セブランス聯合醫學專門學校 校友會",
                "publisher_ko" : "セブランス연합의학전문학교 교우회",
                "library" : "연세대 의과대학△",
                "school_id" : 52903,
                "primaryname" : "セブランス聯合醫學專門學校",
                "primaryname_ko" : "세브란스연합의학전문학교"
            },
            {
                "book_id" : 10932,
                "book_title" : "(旭醫學專門學校) 同窓會名簿 (1943年 4月 現在)",
                "book_title_ko" : "(욱의학전문학교) 동창회명부 (1943년 4월 현재)",
                "publish_date" : "1943.00.00",
                "publish_year" : 1943,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "旭醫學專門學校 同窓會",
                "publisher_ko" : "욱의학전문학교 동창회",
                "library" : "",
                "school_id" : 52917,
                "primaryname" : "旭醫學專門學校",
                "primaryname_ko" : "욱의학전문학교"
            },
            {
                "book_id" : 10933,
                "book_title" : "(崇實專門學校) 會員名簿 (1938年 9月調)",
                "book_title_ko" : "(숭실전문학교) 회원명부 (1938년 9월조)",
                "publish_date" : "1938.10.15",
                "publish_year" : 1938,
                "publish_month" : 10,
                "publish_day" : 15,
                "publisher" : "牟義理 崇實校友會",
                "publisher_ko" : "모의리 숭실교우회",
                "library" : "△",
                "school_id" : 52904,
                "primaryname" : "崇實專門學校",
                "primaryname_ko" : "숭실전문학교"
            },
            {
                "book_id" : 10934,
                "book_title" : "(延禧專門學校) 延禧同硏錄 ",
                "book_title_ko" : "(연희전문학교) 연희동연록 ",
                "publish_date" : "1954.09.15",
                "publish_year" : 1954,
                "publish_month" : 9,
                "publish_day" : 15,
                "publisher" : "金用雨 延禧同門會 本部",
                "publisher_ko" : "금용우 연희동문회 본부",
                "library" : "독립기념관",
                "school_id" : 52905,
                "primaryname" : "延禧專門學校",
                "primaryname_ko" : "연희전문학교"
            },
            {
                "book_id" : 10973,
                "book_title" : "(京畿中學校) 會員名簿 (昭和15年 12月)",
                "book_title_ko" : "(경기중학교) 회원명부 (소화15년 12월)",
                "publish_date" : "1940.12.00",
                "publish_year" : 1940,
                "publish_month" : 12,
                "publish_day" : 0,
                "publisher" : "京畿公立中學校 同窓會",
                "publisher_ko" : "경기공립중학교 동창회",
                "library" : "△",
                "school_id" : 52918,
                "primaryname" : "京畿中學校",
                "primaryname_ko" : "경기중학교"
            },
            {
                "book_id" : 10974,
                "book_title" : "(京畿中學校) 會員名簿 (昭和16年 12月)",
                "book_title_ko" : "(경기중학교) 회원명부 (소화16년 12월)",
                "publish_date" : "1941.12.00",
                "publish_year" : 1941,
                "publish_month" : 12,
                "publish_day" : 0,
                "publisher" : "京畿公立中學校 同窓會",
                "publisher_ko" : "경기공립중학교 동창회",
                "library" : "○",
                "school_id" : 52918,
                "primaryname" : "京畿中學校",
                "primaryname_ko" : "경기중학교"
            },
            {
                "book_id" : 10975,
                "book_title" : "(景福中學校) 同窓會員名簿 (昭和十九年四月現在)",
                "book_title_ko" : "(경복중학교) 동창회원명부 (소화19년4월현재)",
                "publish_date" : "1944.00.00",
                "publish_year" : 1944,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "景福公立中學校 同窓會",
                "publisher_ko" : "경복공립중학교 동창회",
                "library" : "△",
                "school_id" : 52801,
                "primaryname" : "景福中學校",
                "primaryname_ko" : "경복중학교"
            },
            {
                "book_id" : 10976,
                "book_title" : "(京城中學校) 復興記念 會員名簿 ",
                "book_title_ko" : "(경성중학교) 복흥기념 회원명부 ",
                "publish_date" : "1933.00.00",
                "publish_year" : 1933,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "京城公立中學校",
                "publisher_ko" : "경성공립중학교",
                "library" : "",
                "school_id" : 53005,
                "primaryname" : "京城公立中學校",
                "primaryname_ko" : "경성공립중학교"
            },
            {
                "book_id" : 10976,
                "book_title" : "(京城中學校) 復興記念 會員名簿 ",
                "book_title_ko" : "(경성중학교) 복흥기념 회원명부 ",
                "publish_date" : "1933.00.00",
                "publish_year" : 1933,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "京城公立中學校",
                "publisher_ko" : "경성공립중학교",
                "library" : "",
                "school_id" : 52919,
                "primaryname" : "京城中學校",
                "primaryname_ko" : "경성중학교"
            },
            {
                "book_id" : 10977,
                "book_title" : "(公州中學校) 會員名簿 昭和17年用",
                "book_title_ko" : "(공주중학교) 회원명부 소화17년용",
                "publish_date" : "1941.12.20",
                "publish_year" : 1941,
                "publish_month" : 12,
                "publish_day" : 20,
                "publisher" : "武原忠美 公州公立中學校 同窓會",
                "publisher_ko" : "무원충미 공주공립중학교 동창회",
                "library" : "△",
                "school_id" : 52932,
                "primaryname" : "公州中學校",
                "primaryname_ko" : "공주중학교"
            },
            {
                "book_id" : 10978,
                "book_title" : "(普成中學校) 校友會員名簿 (昭和13年 11月 現在)",
                "book_title_ko" : "(보성중학교) 교우회원명부 (소화13년 11월 현재)",
                "publish_date" : "1938.11.00",
                "publish_year" : 1938,
                "publish_month" : 11,
                "publish_day" : 0,
                "publisher" : "普成中學校",
                "publisher_ko" : "보성중학교",
                "library" : "○",
                "school_id" : 27277,
                "primaryname" : "普成中學校",
                "primaryname_ko" : "보성중학교"
            },
            {
                "book_id" : 10978,
                "book_title" : "(普成中學校) 校友會員名簿 (昭和13年 11月 現在)",
                "book_title_ko" : "(보성중학교) 교우회원명부 (소화13년 11월 현재)",
                "publish_date" : "1938.11.00",
                "publish_year" : 1938,
                "publish_month" : 11,
                "publish_day" : 0,
                "publisher" : "普成中學校",
                "publisher_ko" : "보성중학교",
                "library" : "○",
                "school_id" : 52924,
                "primaryname" : "普成中學校",
                "primaryname_ko" : "보성중학교"
            },
            {
                "book_id" : 10979,
                "book_title" : "(全州北中學校) 學友住所錄 ",
                "book_title_ko" : "(전주북중학교) 학우주소록 ",
                "publish_date" : "1944.00.00",
                "publish_year" : 1944,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "全州北中學校",
                "publisher_ko" : "전주북중학교",
                "library" : "",
                "school_id" : 27237,
                "primaryname" : "全州北中學校",
                "primaryname_ko" : "전주북중학교"
            },
            {
                "book_id" : 10979,
                "book_title" : "(全州北中學校) 學友住所錄 ",
                "book_title_ko" : "(전주북중학교) 학우주소록 ",
                "publish_date" : "1944.00.00",
                "publish_year" : 1944,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "全州北中學校",
                "publisher_ko" : "전주북중학교",
                "library" : "",
                "school_id" : 52937,
                "primaryname" : "全州北中學校",
                "primaryname_ko" : "전주북중학교"
            },
            {
                "book_id" : 10980,
                "book_title" : "(中央中學校) 會員名簿 (昭和16年12月 現在)",
                "book_title_ko" : "(중앙중학교) 회원명부 (소화16년12월 현재)",
                "publish_date" : "1941.12.24",
                "publish_year" : 1941,
                "publish_month" : 12,
                "publish_day" : 24,
                "publisher" : "中央校友會",
                "publisher_ko" : "중앙교우회",
                "library" : "○",
                "school_id" : 52936,
                "primaryname" : "中央中學校",
                "primaryname_ko" : "중앙중학교"
            }

    ]

export default MemberDirectoryData;